<div id="footer" class="sticky-footer">
    <!-- Main -->
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-6">
                <p>
                    pakmatti.com is the emerging property portal in Pakistan. We at pakmatti.com provide platform to
                    buyers and sellers that made real estate business easy and convenient. We help you find or list
                    properties online. Our platform allows real estate agents, and property owners to connect with each
                    other. Whether you are on the hunt for an ideal house or commercial property for personal use or
                    investment, we are here to serve you.
                </p>
            </div>
            <div class="col-md-3 col-sm-6 ">
                <h4>Helpful Links</h4>
                <ul class="footer-links">
                    <li><a [routerLink]="'/property/forms/submit'" aria-label="Add Property">Add Property</a></li>
                    <li><a [routerLink]="'/contact-us'" aria-label="Contact Us">Contact Us</a></li>
                    <li><a [routerLink]="'/about-us'" aria-label="About Us">About Us</a></li>
                    <li><a [routerLink]="'/privacy-policy'" aria-label="pakmatti.com Privacy Policy">Privacy Policy</a>
                    </li>
                    <li><a [routerLink]="'/terms-and-conditions'" aria-label="pakmatti.com Terms and Conditions">Terms
                            and Conditions</a></li>
                </ul>
                <div class="clearfix"></div>
            </div>
            <div class="col-md-3  col-sm-12">
                <h4>Contact Us</h4>
                <div class="text-widget">
                    Phone: <a href="tel:03178611123" aria-label="pakmatti.com admin phone number"><span> 031-786-111-23
                        </span></a><br>
                    E-Mail:<span> <a href="mailto:admin@pakmatti.com"
                            aria-label="pakmatti.com admin email address"><span> admin&#64;pakmatti.com </span></a>
                    </span><br>
                </div>
                <ul class="social-icons margin-top-20">
                    <li><a class="facebook" aria-label="pakmatti.com Facebook page"
                            href="https://www.facebook.com/pakmatti" target="_blank"><i class="icon-facebook"></i></a>
                    </li>
                    <li><a class="youtube" aria-label="pakmatti.com YouTube channel"
                            href="https://www.youtube.com/@pakmatti" target="_blank"><i class="icon-youtube"></i></a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- Copyright -->
        <div class="row">
            <div class="col-md-12">
                <div class="copyrights">
                    &copy; {{displayYear}} pakmatti.com, All Rights Reserved.
                </div>
            </div>
        </div>
    </div>
</div>